import { Action, createReducer, on } from '@ngrx/store';

import * as CommonIdGetDesiredUniversitiesActions from '../../actions/common-id/common-id-get-desired-universities.actions';
import { AppError } from 'src/app/errors/app-error';

export interface CommonIdGetDesiredUniversitiesResult {
  success: boolean;
  error: AppError | null;
}

export const commonIdGetDesiredUniversitiesFeatureKey = 'commonIdGetDesiredUniversities';

export interface State {
  result: CommonIdGetDesiredUniversitiesResult | null;
}

export const initialState: State = {
  result: null
};

const commonIdGetDesiredUniversitiesReducer = createReducer(
  initialState,

  /* 最新の志望校の取得 */
  on(CommonIdGetDesiredUniversitiesActions.commonIdGetDesiredUniversitiesSuccess, (state, { response }) => {
    const next: State = {
      ...state,
      result: { success: true, error: null }
    };
    return next;
  }),
  on(CommonIdGetDesiredUniversitiesActions.commonIdGetDesiredUniversitiesFailure, (state, { error }) => {
    const next: State = {
      ...state,
      result: { success: false, error }
    };
    return next;
  }),
  on(CommonIdGetDesiredUniversitiesActions.initializeCommonIdGetDesiredUniversitiesResult, state => {
    const next: State = { ...state, result: null };
    return next;
  })
);

export function reducer(state: State | undefined, action: Action) {
  return commonIdGetDesiredUniversitiesReducer(state, action);
}
